import type { Order } from '@vsf-enterprise/commercetools-types';
import CustomPayment from '~/constants/customPayment';
import { getLastPayment } from '~/helpers/cart/getLastPayment';

export default function (order: Order): Maybe<ValueOf<typeof CustomPayment>> {
  return getLastPayment(order)?.paymentMethodInfo?.paymentInterface;
}
